@defer (on viewport; hydrate on immediate) {
	<div data-test-id="event-overview">
		@for (blok of contentInputs(); track $index) {
			@if (components) {
				<ndc-dynamic
					[ndcDynamicComponent]="components[blok['component']]"
					[ndcDynamicInputs]="blok"
				/>
			}
		}
	</div>
	@if (availableEvents().length > 0) {
		<sb-searchable-list-section
			[persuadeCards]="availableEvents()"
			[title]="listTitle"
			[useStoryblokCards]="false"
		/>
	}
} @placeholder {
	<vp-skeleton />
}
